<template>
  <div></div>
  <!-- <v-container>
    <v-layout row wrap style="max-width:960px" mx-auto>
      <v-row>
        <v-col>
          <h1 class="display-2">Welcome</h1>
          <v-card class="my-8">
            <v-card-text>
              <v-btn color="primary" to="/projects">Project List</v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
  </v-container> -->
</template>

<script>
export default {
  name: 'Home'
}
</script>
